import React from "react";

export default function ChatFooter({ chatBotSetting }) {
  if (chatBotSetting?.showPoweredBy === false) return null;
  return (
    <footer className="chat-footer">
      <span className="chat-brand-mark" aria-hidden="true" />
      <span>Powered by <a href="https://www.botcircuits.com" target="_blank" rel="noopener noreferrer">BotCircuits</a></span>
    </footer>
  );
}
